import React, { useCallback} from 'react'
import { useSelector} from 'react-redux'
import { AddBtn } from '../../../commonComponents/AddBtn'
import { Form, Grid } from 'semantic-ui-react'
import InputField from '../../../commonComponents/formComponents/inputField'
import { useMultipleMerchandiseItem } from '../../hooks/useMultipleMerchandiseItem'
import MerchandiseDutyDetails from './merchandiseDutyDetails'
import { FormTitle } from '../../../commonComponents/FormTitle'
import List from '../../../commonComponents/List'
import { CustomLoader } from '../../../commonComponents/formComponents/loader'

function MerchandiseDuty(props) {
 
  const { merchandiseId, lineItemIndex, isFormDisabled, invoiceIndex, translate, invoiceId } = props
  const ItemDuties = useSelector((state)=>state.InvoicesReducer.invoices.find(invoice=>invoice.invoiceId===invoiceId).
  merchandiseList.find(merch=>merch.merchandiseId===merchandiseId).itemDuties)

  const totalAmount = useSelector((state)=>state.InvoicesReducer.invoices.find(invoice=>invoice.invoiceId===invoiceId).
  merchandiseList.find(merch=>merch.merchandiseId===merchandiseId).totalAmount)

  const {
    isLoading,
    AddItem,
    deleteItem,
    updateItem,
    saveItem,
    copyData
  } = useMultipleMerchandiseItem({tableName:"itemDuties",fieldIdName:"merchandiseDutyId",invoiceId,merchandiseId})

  const renderItem = useCallback((item,index)=>{
    return (
     <MerchandiseDutyDetails
     key={item.merchandiseDutyId}
     item={item}
     dutyIndex={index}
     deleteItem={deleteItem}
     updateItem={updateItem}
     saveItem={saveItem}
     copyData={copyData}
     lineItemIndex={lineItemIndex}
     invoiceIndex={invoiceIndex}
     translate={translate}
     isFormDisabled={isFormDisabled}
     />
    )
  },[translate,updateItem,saveItem,deleteItem,copyData,lineItemIndex,invoiceIndex])


return(

  <Form.Group className='float-container mb-2'>
 <FormTitle boxNumber="47" title={translate('DUTIES_VAT', { ns: ['default', 'lineItem'] })}></FormTitle>
 <List dataSource={ItemDuties} renderItem={renderItem} />
  {isLoading && <CustomLoader />}

  {ItemDuties?.length>0 &&(<Grid style={{marginTop:'10px'}}>
          <Grid.Row>
            <Grid.Column
              width='15'
              className='divFormFeild border-bottom b-brr-5 b-trr-5 b-blr-5 b-tlr-5'
            >
              <InputField
                id={`totalAmount-${invoiceId}-${merchandiseId}`}
                value={totalAmount}
                string={" TOTAL: €"}
                className={'field-bg'}
                addThousandsSeperator={true}
                disabled={true}
              />
            </Grid.Column>
            <Grid.Column width='1'>

            </Grid.Column>
          </Grid.Row>
        </Grid>)}

          {ItemDuties?.length < 99 && (
          <AddBtn disabled={(isFormDisabled)} 
          onClick={()=>AddItem({"merchandiseDutyId": ""})}
          text='Add'></AddBtn>
        )}
  </Form.Group>

)
}

export default React.memo(MerchandiseDuty)
